import { Component, OnInit, ViewChild, Inject, PLATFORM_ID, PendingTasks } from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';
import { CharityService } from 'src/app/services/Charity.service';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { RegisterService } from 'src/app/services/Register.service';
import { OwlOptions } from 'ngx-owl-carousel-o';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MainService } from 'src/app/main.service';
import { SharedModule } from '../../../share/shared.module';
import { isPlatformBrowser } from '@angular/common';
import { CanonicalService } from 'src/app/services/canonical.service';
import { CmsPageSeoService } from 'src/app/services/cms-page-seo.service';
import { SsrStatusService } from 'src/app/services/ssr-status.service';
import { isNoIndexCharitySlug } from 'src/app/services/noindex-routes';
import { NotFoundComponent } from '../../not-found/not-found.component';
import * as globalConstant from '../../../global_constant';
import { finalize } from 'rxjs/operators';

@Component({
	selector: 'app-charity-details',
	standalone: true,
	imports: [
		SharedModule,
		NotFoundComponent,
	],
	templateUrl: './charity-details.component.html',
	styleUrls: ['./charity-details.component.css']
})
export class CharityDetailsComponent implements OnInit {

	@ViewChild('videoPopupModal', { static: false }) public videoPopupModal: ModalDirective;
	charity_detail_data: any;
	charity_detail_url = '';
	profile_url = '';
	slug: any;
	authUser: any = "";
	loading = false;
	isLoggedIn = false;
	token = '';
	featuredImage = "";
	charity_video_url: SafeResourceUrl;
	SubscribeForm: FormGroup;
	submitted = false;
	subscribe_error_message: any = '';
	isBrowser: boolean;
	siteUrl: String = globalConstant?.WEBSITE_URL;
	pageUrl = '';
	selectedTab = 0;
	isPageReady = false;
	private pageNotFoundState = false;
	get pageNotFound(): boolean {
		return this.pageNotFoundState;
	}
	set pageNotFound(value: boolean) {
		this.pageNotFoundState = value;
		if (value) {
			this.ssrStatus.notFound();
		}
	}

	constructor(
		private charityService: CharityService,
		private canonicalService: CanonicalService,
		private cmsPageSeoService: CmsPageSeoService,
		private metaService: Meta,
		private titleService: Title,
		public router: Router,
		private registerService: RegisterService,
		public sanitizer: DomSanitizer,
		private formBuilder: FormBuilder,
		private mainService: MainService,
		private pendingTasks: PendingTasks,
		private ssrStatus: SsrStatusService,
		@Inject(PLATFORM_ID) platformId: Object
	) {
		let currenturl = this.router.url;
		let componentUrl = currenturl.startsWith('/') ? currenturl.slice(1) : currenturl;
		const canonicalUrl = this.normalizeUrl(this.siteUrl + componentUrl);
		this.pageUrl = this.canonicalService.setCanonical(canonicalUrl);
		this.isBrowser = isPlatformBrowser(platformId);

		if (this.isBrowser) {

			if (typeof window !== 'undefined') {
				window.scrollTo(0, 0);
			}
		}
		this.slug = this.router?.url?.split('/')[2];
		this.applyNoIndexIfExcludedCharity();
		if (this.isBrowser) {
			if (typeof localStorage !== 'undefined') {
				if (localStorage.getItem('authUser')) {
					this.authUser = JSON.parse(localStorage.getItem('authUser'));
					this.isLoggedIn = true;
					this.token = localStorage.getItem('login_token');
				}
			}
		}
	}

	private isExcludedFromIndex(): boolean {
		return isNoIndexCharitySlug(this.slug);
	}

	private applyNoIndexIfExcludedCharity(): void {
		if (!this.isExcludedFromIndex()) {
			return;
		}
		this.metaService.updateTag({ name: 'robots', content: 'noindex, nofollow' });
		this.ssrStatus.noIndex();
	}

	normalizeUrl(url: string): string {
		return url.endsWith('/') ? url.slice(0, -1) : url; // Remove trailing slash if present
	}
	ngOnInit() {
		this.charity_Data();
		this.SubscribeForm = this.formBuilder.group({
			email: ['', [Validators.required, Validators.email]],
		});
	}

	get subscribeFormCtrl() {
		return this.SubscribeForm.controls;
	}

	onSubscribeSubmit() {
		this.submitted = true;
		this.loading = true;

		this.subscribe_error_message = '';

		// stop here if form is invalid
		if (this.SubscribeForm.invalid) {
			this.loading = false;
			return;
		} else {

			let reuestBody = { 'email': this.SubscribeForm?.get('email')?.value?.replace(/^\s+|\s+$/gm, '') };
			this.mainService.subscribeUser(reuestBody).subscribe(res => {
				if (res.response == "success") {
					this.loading = false;
					this.SubscribeForm.controls['email'].setValue('');
					this.router.navigate(['/thanksforsubscribing']);
					this.submitted = false;
				} else {
					this.loading = false;

					this.subscribe_error_message = res.message;

				}
			});
		}
	}
	charity_Data() {
		let requestBody = { "charity_slug": this.slug };
		this.isPageReady = false;
		const taskCleanup = this.pendingTasks.add();
		this.charityService.get_charity(requestBody)
			.pipe(finalize(() => taskCleanup()))
			.subscribe({
				next: (res) => {
					const charity = res?.data;
					if (res?.response === 'success' && charity?.status == 1) {
						this.charity_detail_data = charity;
						this.addMetaTags();
						this.charity_detail_url = res.charity_base_url;
						this.profile_url = res.profile_image_url;
						this.isPageReady = true;
						return;
					}
					this.pageNotFound = true;
					this.isPageReady = true;
				},
				error: () => {
					this.pageNotFound = true;
					this.isPageReady = true;
				},
			});
	}
	getWebsiteUrl(url?: string): string {
		if (!url) return '';
		const trimmed = url.trim();
		return /^https?:\/\//i.test(trimmed) ? trimmed : `https://${trimmed}`;
	  }

	owlExpDetail: OwlOptions = {
		loop: false,
		mouseDrag: false,
		autoplay: true,
		touchDrag: true,
		pullDrag: false,
		dots: false,
		autoWidth: true,
		navSpeed: 700,
		navText: ['1', '2'],
		nav: false,
		items: 1,
		rewind: true

	}

	owlCharityDetail = {
		mouseDrag: false,
		margin: 0,
		autoplayTimeout: 7000,
		transitionStyle: "slide",
		touchDrag: true,
		autoplay: true,
		lazyLoad: true,
		items: 1,
		smartSpeed: 500,
		nav: false,
		loop: true,
		dots: false,
		autoplayHoverPause: true,
	}

	charitySelection(charity_id) {
		this.loading = true;
		let requestBoady = { 'charity_choosed': charity_id }
		this.registerService.register_couple_charity_step_6(requestBoady, this.token).subscribe(res => {
			if (res.response == "success") {
				if (this.isBrowser) {
					if (typeof localStorage !== 'undefined') {
						localStorage.setItem('authUser', JSON.stringify(res.data));
						this.authUser = JSON.parse(localStorage.getItem('authUser'));
					}
				}
				this.charity_Data;
				setTimeout(() => {
					this.loading = false;
				}, 1000);
			} else {
				this.loading = false;
				//this.toastr.errorToastr(res.message, 'Error!'); 
			}
		});
	}
	videoPopup(event) {
		this.charity_video_url = this.sanitizer.bypassSecurityTrustResourceUrl(event);
		//console.log("start")
		//console.log(event);
		//console.log(event);
		this.videoPopupModal.show();

	}

	addMetaTags() {
		const name = (this.charity_detail_data?.company_name || this.charity_detail_data?.title || '').trim();
		const fallbackTitle = name
			+ (this.charity_detail_data?.location ? ' - ' + this.charity_detail_data.location : '');
		const stripHtml = (value: any) => (value || '')
			.toString()
			.replace(/<[^>]*>/g, ' ')
			.replace(/\s+/g, ' ')
			.trim();
		const fallbackDescription = stripHtml(this.charity_detail_data?.seo_description)
			|| stripHtml(this.charity_detail_data?.summary)
			|| stripHtml(this.charity_detail_data?.details)
			|| ("Know about " + name
				+ (this.charity_detail_data?.location ? ' - ' + this.charity_detail_data.location : '')
				+ " here at Spur Experiences. Know about contact numbers, email & location of this charity.");

		const logoUrl = this.charity_detail_data?.profile_image && this.profile_url
			? this.profile_url + this.charity_detail_data.profile_image
			: (this.charity_detail_data?.image_url || '');
		const imageUrl = this.charity_detail_data?.cover_image && this.profile_url
			? this.profile_url + this.charity_detail_data.cover_image
			: (this.charity_detail_data?.image && this.charity_detail_url
				? this.charity_detail_url + this.charity_detail_data.image
				: (this.charity_detail_data?.image_url || logoUrl || ''));
		const websiteUrl = this.getWebsiteUrl(this.charity_detail_data?.website);
		const email = (this.charity_detail_data?.email || '').toString().trim();
		const telephone = (this.charity_detail_data?.phone_number || '').toString().trim();
		const locationText = stripHtml(this.charity_detail_data?.location);

		const ngoNode: any = {
			'@type': ['NGO', 'Organization'],
			'@id': this.pageUrl + '#organization',
			name: name || fallbackTitle,
			url: this.pageUrl,
		};
		if (fallbackDescription) {
			ngoNode.description = fallbackDescription;
		}
		if (logoUrl) {
			ngoNode.logo = logoUrl;
		}
		if (imageUrl) {
			ngoNode.image = imageUrl;
		}
		if (websiteUrl) {
			ngoNode.sameAs = [websiteUrl];
		}
		if (email) {
			ngoNode.email = email;
		}
		if (telephone) {
			ngoNode.telephone = telephone;
		}
		if (locationText) {
			ngoNode.address = {
				'@type': 'PostalAddress',
				description: locationText,
			};
		}

		const siteRoot = (this.siteUrl || 'https://spurexperiences.com/').toString().replace(/\/?$/, '/');
		this.cmsPageSeoService.applyEntitySeo({
			...this.charity_detail_data,
			seo_title: this.charity_detail_data?.seo_title || '',
			title: fallbackTitle,
			seo_description: fallbackDescription,
			image_url: imageUrl,
		}, {
			pageUrl: this.pageUrl,
			schemaType: 'WebPage',
			skipSchema: this.isExcludedFromIndex(),
			extraSchemaNodes: this.isExcludedFromIndex() ? [] : [ngoNode],
			breadcrumbs: [
				{ name: 'Home', url: siteRoot },
				{ name: 'Charities', url: this.normalizeUrl(siteRoot + 'charities') },
				{ name: name || fallbackTitle || 'Charity', url: this.pageUrl },
			],
		});
		this.applyNoIndexIfExcludedCharity();
	}

	tab_change(selectedTab) {
		if (selectedTab == 0) {
			this.selectedTab = 0;
		} else if (selectedTab == 1) {
			this.selectedTab = 1;
		} else if (selectedTab == 2) {
			this.selectedTab = 2;
		} else {
			this.selectedTab = 0;
		}
	}

}
